"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspaceUnavailabilityCategories = exports.getWorkspaceUnavailabilityCategories = exports.UNAVAILABILITY_VALUE = exports.AVAILABILITY_VALUE = void 0;
const __1 = require("..");
const maybe_unwrap_1 = require("../apollo/maybe-unwrap");
const is_defined_1 = require("../is-defined");
const useWorkspace_1 = require("./useWorkspace");
exports.AVAILABILITY_VALUE = 'availability';
exports.UNAVAILABILITY_VALUE = 'unavailability';
const getWorkspaceUnavailabilityCategories = (workspace) => {
    if ((0, is_defined_1.isUndefined)(workspace))
        return [];
    const unavCategories = workspace.unavailabilityCategories?.filter(is_defined_1.isValue).map((cat) => ({
        id: (0, maybe_unwrap_1.unwrapMaybe)(cat.id),
        type: 'HARD',
        name: (0, maybe_unwrap_1.unwrapMaybe)(cat.title && cat.title !== '' ? cat.title : (0, __1.t)('UNAV_CAT_NO_TITLE')),
        tag: (0, maybe_unwrap_1.unwrapMaybe)(cat.tag && cat.tag !== '' ? cat.tag : (0, __1.t)('UNAV_CAT_NO_TAG')),
        archived: (0, maybe_unwrap_1.unwrapMaybe)(cat.archived),
        employeeCanRequest: (0, maybe_unwrap_1.unwrapMaybe)(cat.employeeCanRequest),
        maxDailyMinutes: (0, maybe_unwrap_1.unwrapMaybe)(cat.maxDailyMinutes),
        maxYearlyDays: (0, maybe_unwrap_1.unwrapMaybe)(cat.maxYearlyDays),
        vacation: (0, maybe_unwrap_1.unwrapMaybe)(cat.vacation),
        displayWorkTimeAsDays: (0, maybe_unwrap_1.unwrapMaybe)(cat.displayWorkTimeAsDays),
        timeInLieu: (0, maybe_unwrap_1.unwrapMaybe)(cat.timeInLieu),
    }));
    if ((0, is_defined_1.isUndefined)(unavCategories))
        return [];
    // availabilities
    unavCategories.push({
        id: exports.AVAILABILITY_VALUE,
        available: true,
        type: 'SOFT',
        name: (0, maybe_unwrap_1.unwrapMaybe)((0, __1.t)('UNAV_UNAVAILABLE_AVAIL')),
        tag: '🟢',
        archived: false,
        employeeCanRequest: true,
    });
    // unavailabilities
    unavCategories.push({
        id: exports.UNAVAILABILITY_VALUE,
        available: false,
        type: 'SOFT',
        name: (0, maybe_unwrap_1.unwrapMaybe)((0, __1.t)('UNAV_UNAVAILABLE')),
        tag: '🟠',
        archived: false,
        employeeCanRequest: true,
    });
    return unavCategories;
};
exports.getWorkspaceUnavailabilityCategories = getWorkspaceUnavailabilityCategories;
const useWorkspaceUnavailabilityCategories = () => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    return (0, exports.getWorkspaceUnavailabilityCategories)(workspace);
};
exports.useWorkspaceUnavailabilityCategories = useWorkspaceUnavailabilityCategories;
